import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ACCOUNTBALANCES_DOWNLOAD: MijnRoute = {
    path: 'rekeningstanden-downloaden',
    navigationEvent: 'toRekeningstandenDownloaden',
    regex: /^\/zelf-regelen\/rekeningstanden-downloaden$/,
    webcomponent: 'mijn-rekeningstanden-downloaden-webcomponent'
};
